import type { TypedClient } from '@platform/openapi';
import { Plus } from 'lucide-react';
import { useRef, useState, type MouseEvent } from 'react';
import { QuickAddStock } from '../../inventory/QuickAddStock.tsx';
import type { StockRow } from '../../inventory/StockMatrix.tsx';
import { usePageContext } from '../../usePageContext.ts';
import styles from './ProductList.module.css';

export type QuickAddStockButtonProps = {
  readonly api: TypedClient;
  readonly productName: string;
  readonly rows: readonly StockRow[];
};

export const QuickAddStockButton = ({ api, productName, rows }: QuickAddStockButtonProps) => {
  const { t } = usePageContext();
  const anchor = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const label = t('common.rowAction', { action: t('quickStock.title'), name: productName });

  const toggle = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen((current) => !current);
  };

  return (
    <>
      <button
        ref={anchor}
        type="button"
        className={styles['quickAdd']}
        aria-label={label}
        title={label}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={toggle}
      >
        <Plus size={16} aria-hidden="true" />
      </button>
      {open ? (
        <QuickAddStock
          api={api}
          anchor={anchor}
          productName={productName}
          rows={rows}
          onClose={() => {
            setOpen(false);
          }}
        />
      ) : null}
    </>
  );
};
